import { render, staticRenderFns } from "./DashboardGraph.vue?vue&type=template&id=35cb6ad7&scoped=true&"
import script from "./DashboardGraph.vue?vue&type=script&lang=js&"
export * from "./DashboardGraph.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGraph.vue?vue&type=style&index=0&id=35cb6ad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb6ad7",
  null
  
)

export default component.exports